import React from "react";

import {
  Button,
  Checkbox,
  message,
  Modal,
  Space,
  Table,
  Typography,
} from "antd";
import Text from "antd/lib/typography/Text";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteCostCenterField,
  deleteCostCenterField,
  getCostCenterField,
  UpdateCostCenterField,
  updateCostCenterField,
  AddCostCenterField,
} from "../../../../actions/companySettings";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import { hasAccess, objectToFormData } from "../../../../utils";
import PageHeader from "../../../PageHeader";
import { employees } from "./../../../../actions/employees";
import "./../../styles/setting.css";
import "./../Custom.css";
import AddCostCentersField from "./AddCostCenterField";

const { Title } = Typography;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Cost Center Head",
    dataIndex: "user_name",
    key: "user_name",
  },
];

message.config({
  maxCount: 3,
});

const CostCenter = () => {
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setIsModalType] = React.useState("center");
  const [selectedId, setSelectedId] = React.useState("");
  const [costCenterFields, setCostCenterFields] = React.useState([]);
  const [employeesData, setemployeesData] = React.useState([]);

  const updateCompanySettingResponse = useSelector(
    (state) => state.companySetting.updateCompanySetting || {},
  );
  const costCenterFieldResponse = useSelector(
    (state) => state.companySetting.getCostCenterField || {},
  );
  const deleteCostCenterFieldResponse = useSelector(
    (state) => state.companySetting.deleteCostCenterField || {},
  );
  const addCostCenterFieldResponse = useSelector(
    (state) => state.companySetting.addCostCenterField || {},
  );
  const updateCostCenterFieldResponse = useSelector(
    (state) => state.companySetting.updateCostCenterField || {},
  );
  const employeesResponse = useSelector(
    (state) => state.employees.employees || {},
  );
  const {
    data: { response: { employees: employeesRecord = [] } = {} } = {},
    success = false,
  } = employeesResponse;

  React.useEffect(() => {
    // dispatch(companySetting({ show: 'id' }));
    dispatch(getCostCenterField({}));
    dispatch(employees(objectToFormData({ status: true })));
    // setIsModalVisible(false,);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (success) {
      setemployeesData(employeesRecord);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeesResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = false, errors = "" } = {},
    } = updateCompanySettingResponse;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCompanySettingResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = updateCostCenterFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getCostCenterField({}));
      dispatch({
        type: UpdateCostCenterField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: UpdateCostCenterField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCostCenterFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = deleteCostCenterFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getCostCenterField({}));
      dispatch({
        type: DeleteCostCenterField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: DeleteCostCenterField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteCostCenterFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = addCostCenterFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getCostCenterField({}));
      dispatch({
        type: AddCostCenterField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: AddCostCenterField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addCostCenterFieldResponse]);

  React.useEffect(() => {
    const {
      data: { response: { costcenters = [] } = {}, status = false } = {},
    } = costCenterFieldResponse;
    if (status) {
      setCostCenterFields(costcenters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [costCenterFieldResponse]);

  const tableAction = [
    {
      title: "Enable",
      dataIndex: "is_enable",
      key: "is_enable",
      render: (is_enable, record) => (
        <Checkbox
          key={record.id}
          onChange={(e) =>
            dispatch(
              updateCostCenterField(
                objectToFormData({
                  id: record.id,
                  is_enable: e.target.checked,
                }),
              ),
            )
          }
          defaultChecked={is_enable}
          disabled={!hasAccess("cost_center", "write")}
        ></Checkbox>
      ),
    },
    {
      title: "Actions",
      key: "action",
      render: (text, record) =>
        hasAccess("cost_center", "write") && (
          <Space key={record.id} size="middle">
            <button onClick={() => showEditModal(record.id)}>
              <img src={EditIcon} alt={"logo"} className="action-logo" />
            </button>
            <button onClick={() => showDeleteModal(record.id)}>
              <img src={DeleteIcon} alt={"logo"} className="action-logo" />
            </button>
          </Space>
        ),
    },
  ];

  const showModal = () => {
    setSelectedId("");
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("center");
  };

  const showEditModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const renderDeleteOption = () => {
    return (
      <>
        <Text>
          If you delete this Cost Center, the users will not no longer be
          associated to this Cost Center. Are you sure you want to delete it?
        </Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() =>
            dispatch(
              deleteCostCenterField(objectToFormData({ id: selectedId })),
            )
          }
        >
          Delete
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  function handleButtonClick(e) {
    showModal();
  }

  return (
    <>
      <Modal
        title={
          modalType === "center" ? (
            <>
              <img src={DeleteIcon} alt={"logo"} className="action-logo" />{" "}
              Delete Cost Center
            </>
          ) : (
            <Title level={4}>
              {selectedId ? "Edit Cost Center" : "New Cost Center"} &nbsp;
              <span className="text-small">Enter details and submit</span>
            </Title>
          )
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className={
          modalType === "center"
            ? "center-aligned-modal"
            : "right-alinged-modal-small"
        }
      >
        {modalType === "center" ? (
          renderDeleteOption()
        ) : (
          <AddCostCentersField
            id={selectedId}
            handleCancel={handleCancel}
            employeesData={employeesData}
          />
        )}
      </Modal>
      <div className="heading-div">
        <PageHeader
          title={`Cost Center`}
          navigation={{
            Home: "/dashboard/",

            Customisation: "/setting/customisation/",
            "Cost Center": null,
          }}
        />
      </div>
      {hasAccess("cost_center", "write") && (
        <Button onClick={handleButtonClick} className="mb1 ml1 addNew">
          <img src={AddNewIcon} alt={"logo"} className="addNew-logo" />
          Add New
        </Button>
      )}
      <Table
        rowKey="id"
        columns={[...columns, ...tableAction]}
        dataSource={costCenterFields}
        className="settingsTable"
      />
    </>
  );
};

export default CostCenter;
